import { PayloadAction } from '@reduxjs/toolkit';
import { takeEvery, put } from 'redux-saga/effects';
import { ApiError } from 'src/api';
import { uuidV4 } from 'src/helper';
import { addNotification } from 'src/store/reducers/popUpNotifications';
import { clearAuthState } from 'src/store/reducers/auth';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function* rootNotificationSaga() {
  yield takeEvery('*', watchRejectedActions);
}

function* watchRejectedActions(action: PayloadAction<ApiError>) {
  const { type, payload } = action;

  if (type.includes('/rejected')) {
    if (payload?.code === 'error.AccountTokenExpiredError') {
      yield put(clearAuthState());

      if (type !== 'auth/account/rejected') {
        yield put(
          addNotification({
            uuid: uuidV4(),
            type: 'error',
            title: 'error.sessionExpired',
            timeout: 3000,
          }),
        );
      }
    }

    yield put(
      addNotification({
        uuid: uuidV4(),
        type: 'error',
        title: payload?.code || 'error.unknownError',
        timeout: 3000,
      }),
    );
  }
}

export default rootNotificationSaga;
